"use client";

import RegisterLoginLayout from "@/app/versioning/page/RegisterLoginLayout";

export default RegisterLoginLayout;
